module.exports = __webpack_public_path__ + "static/scale-model-of-chattanooga-zoo-in-chattanooga-tennessee-eaef27bb9a99b755a9a1c14d75ddb704.png";